const middleware = {}

middleware['is_admin'] = require('../middleware/is_admin.js');
middleware['is_admin'] = middleware['is_admin'].default || middleware['is_admin']

middleware['is_anon_admin'] = require('../middleware/is_anon_admin.js');
middleware['is_anon_admin'] = middleware['is_anon_admin'].default || middleware['is_anon_admin']

middleware['is_anonymous'] = require('../middleware/is_anonymous.js');
middleware['is_anonymous'] = middleware['is_anonymous'].default || middleware['is_anonymous']

middleware['is_authenticated'] = require('../middleware/is_authenticated.js');
middleware['is_authenticated'] = middleware['is_authenticated'].default || middleware['is_authenticated']

middleware['is_not_validated'] = require('../middleware/is_not_validated.js');
middleware['is_not_validated'] = middleware['is_not_validated'].default || middleware['is_not_validated']

middleware['is_validated'] = require('../middleware/is_validated.js');
middleware['is_validated'] = middleware['is_validated'].default || middleware['is_validated']

export default middleware
